

import comments from "@/mixins/data"
import ClientHead from "@/components/main/core/ClientHead.vue"
import RedSection from "@/components/main/core/RedSection"
import AlreadyUsing from "@/components/landing/landing-free/already-using";
import Comments from "@/components/landing/landing-free/comments";
import FeedBack from "@/components/main/forms/FeedBack";
import CheckBox from "@/components/main/core/CheckBox";

export default {

  head() {
    const title = 'Choose Best Apps for Catching Cheaters Online | iFindCheaters Reviews';
    const description = 'Discover reviews and ratings of iFindCheater. Hear from real users who have discovered the truth with iFindCheaters.Read our testimonials and join those who took charge of their relationships.';

    return {
      title: title,
      meta: [
      {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Real Stories, catch cheating spouse, hidden profile finder, find hidden dating profiles, verify spouse online, online infidelity search, spouse tracker app, uncover secret profiles, detect cheating partner, find spouse on dating sites, catch cheating partner'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/testimonials/",
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Recommendations about the service",
            }],
          }
        }
      ]
    };
  },

  name: "testimonials",
  layout: 'clientLayout',
  mixins: [comments],
  data() {
    return {
      isAccepted: false,
    }
  },
  methods: {
    accept() {
      this.isAccepted = !this.isAccepted
    },
  },
  components: {FeedBack, ClientHead, RedSection, CheckBox, AlreadyUsing, Comments,  },
  mounted() {
    this.isAccepted = false;
  }
}
